import { ErrorHandler, Injectable } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { environment } from "environments/environment";

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {

    public handleError(error: any): void {
        // Always log to console for debugging
        if (error instanceof HttpErrorResponse) {
            console.error(`HTTP Error ${error.status}: ${error.message}`, {
                url: error.url,
                statusText: error.statusText,
                timestamp: new Date().toISOString()
            });
        } else {
            console.error('Application Error:', {
                message: error?.message || 'Unknown error',
                stack: error?.stack,
                timestamp: new Date().toISOString()
            });
        }

        // In production, you might want to send errors to your backend
        if (environment.production) {
            // Optional: Send to your monitoring service
            // this.sendToMonitoringService(error);
        }
    }

    // Optional: Method to send errors to your own monitoring service
    // private sendToMonitoringService(error: any): void {
    //     // Implement your own error reporting logic here
    // }
}